"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ShareButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _Share = _interopRequireDefault(require("./Share"));
function ShareButton(props) {
  var className = props.className,
    children = props.children,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, ["className", "children"]);
  return _react.default.createElement(_Share.default, rest, function (_ref) {
    var loading = _ref.loading,
      handleClick = _ref.handleClick;
    return _react.default.createElement("button", {
      type: "button",
      disabled: loading,
      className: className,
      onClick: handleClick
    }, children);
  });
}
ShareButton.defaultProps = (0, _extends2.default)({}, _Share.default.defaultProps, {
  className: undefined
});